<template>
  <div id="maskLayer" v-if="show" @click="cancelMaskLayer">
    <div class="mask-upload" v-if="type === 'upload'">
      <i class="el-icon-loading"></i>
      <p>{{ text }}</p>
    </div>
    <img
      v-if="type === 'preview' && imgSrc"
      class="mask-preview"
      :src="imgSrc"
      alt=""
      @click.stop
    />
  </div>
</template>

<script>
export default {
  name: "maskLayer",
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    text: {
      type: String,
      required: false,
      default: "正在上传中...",
    },
    type: {
      type: String,
      required: true,
      default: "upload",
    },
    imgSrc: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      showMask: false,
    };
  },
  methods: {
    cancelMaskLayer() {
      if (this.type === "preview") {
        this.$emit("handleCancelPreviewImage");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#maskLayer {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 29999;
  display: flex;
  justify-content: center;
  align-items: center;
  .mask-upload {
    text-align: center;
    i {
      font-size: 36px;
      color: #e40080;
    }
    p {
      margin: 20px 0;
      font-size: 20px;
      color: #e40080;
    }
  }
  .mask-preview {
    width: 800px;
    object-fit: contain;
    display: block;
  }
}
</style>